import { render, staticRenderFns } from "./departFinder.vue?vue&type=template&id=4287f76a&"
import script from "./departFinder.vue?vue&type=script&lang=js&"
export * from "./departFinder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports